import { useEffect, useState } from "react";
import { BankAccountList } from "./BankAccountList";
import { UserBankAccountDetail } from "../../models/response/retrieveUserBankAccountResponse";
import { BankAccountDetail } from "./BankAccountDetail";
import { BankingForm } from "./BankAccountForm";
import { userPendingStore } from "../../../users/store/userPendingData.store";

export type ViewMode = "add" | "edit" | "list" | "detail";

export function Banking() {

  const [viewMode, setViewMode] = useState<ViewMode>("list");
  const [selectedAccount, setSelectedAccount] =
    useState<UserBankAccountDetail | null>(null);

  useEffect(() => {
    userPendingStore.getState().fetchPendingData();
  }, []);

  const handleAddButton = () => {
    setViewMode("add");
    setSelectedAccount(null);
  };


  const handleEditButton = (bankAccount: UserBankAccountDetail) => {
    setSelectedAccount(bankAccount);
    setViewMode("edit");
  };

  const handleViewButton = (bankAccount: UserBankAccountDetail) => {
    setSelectedAccount(bankAccount);
    setViewMode("detail");
  };

  const handleBackButton = () => {
    setViewMode("list");
    setSelectedAccount(null);
  };

  let content = null;


  switch (viewMode) {
    case "add":
      content = <BankingForm handleBackButton={handleBackButton} />;
      break;
    case "edit":
      content = <BankingForm bankAccount={selectedAccount!} handleBackButton={handleBackButton} />;
      break;
    case "list":
      content = <BankAccountList handleEditButton={handleEditButton} handleViewButton={handleViewButton} handleAddButton={handleAddButton} />;
      break;
    case "detail":
      content = <BankAccountDetail bankAccount={selectedAccount!} handleBackButton={handleBackButton} />;
      break;
  }

  return (
    <div>
      {content}
    </div>
  );
}
